import ListStore from '@/store/core/ListStore';
import { action, computed, override } from 'mobx';
import services from '@/api/services';
import { Partners } from '@/store/types';
import { statuses, partnerTypes } from '@/store/mapping';
import { dateFormat } from '@/utils/filters';

export default class BusinessPartnersStore extends ListStore {
  @override
  filters = {
    name: '',
    tin: '',
    createDate: '',
    type: null,
    status: null,
  };

  @computed get processedData() {
    if (!this.data?.items || !this.data?.items?.length) return;
    const items = this.data.items.map((item: Partners) => ({
      ...item,
      type: partnerTypes[item.type] || '-',
      createDate: dateFormat(item.createDate, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
    }));

    return { ...this.data, items };
  }

  @action.bound async fetch() {
    this.isFetching = true;
    try {
      const { data } = await services.business.getPartnersList(
        this.notFalsyParams,
      );
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
